import { render, staticRenderFns } from "./MultiBranding.vue?vue&type=template&id=98d00326&"
import script from "./MultiBranding.vue?vue&type=script&lang=js&"
export * from "./MultiBranding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports